






import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class extends Vue {
  @Prop(String) readonly elementId!: string

  onClick () {
    const ele = document.getElementById(this.elementId)
    if (ele) {
      ele.scrollIntoView()
    }
  }
}
